<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="120px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="name">
                <el-input v-model="formParameter.name" autocomplete="off"></el-input > 
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开户类型" prop="kftype">
              <el-switch v-model="kftype"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="kftype" label="开平台的公司" prop="cpmnm">
              <el-select v-model="formParameter.cpmnm" placeholder="请选择">
                <el-option
                  v-for="item in companies"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="!kftype" label="开平台员工" prop="usrname"
              ><el-input v-model="formParameter.usrname" autocomplete="off"></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="登录网址" prop="netaddress"
              ><el-input
                v-model="formParameter.netaddress"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="登录账号" prop="login"
              ><el-input
                v-model="formParameter.login"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="passwd"
              ><el-input
                v-model="formParameter.passwd"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="开始时间" prop="begintime">
              <el-date-picker
                v-model="cdates"
                value-format="yyyy-MM-dd"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 70%; margin-right: 18px"
              >
              </el-date-picker>
              <span> 工期为:{{ days }}天</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="每月单价" prop="price"
              ><el-input
                v-model="formParameter.price"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="评级" prop="rank">
              <el-rate v-model="formParameter.rank"> </el-rate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经办人" prop="contact"
              ><el-input
                v-model="formParameter.contact"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经办人电话" prop="mobile"
              ><el-input
                v-model="formParameter.mobile"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark"
              ><el-input
                v-model="formParameter.remark"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/recruplatform/recruplatform.js";
import apicpy from "@/api/consu/recrucompany/recrucompany.js";
export default {
  name: "edit",
  components: {
    popup,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      cdates:[],
      companies: [],
      kftype: true,
      days: 0,
      rules: {
        //登录ip
        netaddress: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 200,
            trigger: "blur",
          },
        ],
        //客户端
        login: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: "blur",
          },
        ],
        //登录时间
        passwd: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: "blur",
          },
        ],

        //评级
        rank: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 11,
            trigger: "blur",
          },
        ],
        //联系人
        contact: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    "cdates": {
      handler() {
        if (
          this.formParameter.cdates &&
          this.formParameter.cdates[0] &&
          this.formParameter.cdates[1]
        ) {
          this.formParameter.begintime = this.formParameter.cdates[0];
          this.formParameter.endtime = this.formParameter.cdates[1];
          // console.log(a);
          let btm = new Date(this.formParameter.begintime).getTime();
          let etm = new Date(this.formParameter.endtime).getTime();
          // console.log("da", (xxa - xx) / 86400000);
          this.days = (etm - btm) / 86400000;
        } else {
          this.days = 0;
        }
      },
      deep: true,
      immdeiate: true,
    },
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, "45%");
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        if (this.kftype) {
          this.formParameter.usrname = null;
        } else {
          this.formParameter.cpmnm = null;
        }

        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$emit("flush");
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$emit("flush");
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;

         if( this.formParameter.usrname ){
             this.kftype =false
         }else{
            this.kftype =true
         }
         
         
         if( this.formParameter.begintime){
                this.cdates.push(  this.formParameter.begintime )
                this.cdates.push(  this.formParameter.endtime )
         }
 
          this.popupLoading = false;
        });
      } else {
        //添加
        this.popupLoading = false;
      }

      apicpy.listsnm({}, (res) => {
        this.companies = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
